"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentExecutorSchema = exports.AGENT_EXECUTOR_TYPE = void 0;
const zod_1 = require("zod");
const trigger_executor_1 = require("../trigger-executor");
exports.AGENT_EXECUTOR_TYPE = 'agent';
exports.AgentExecutorSchema = trigger_executor_1.TriggerExecutorSchema.extend({
    executorType: zod_1.default.literal(exports.AGENT_EXECUTOR_TYPE),
    agentId: zod_1.default.string(),
});
//# sourceMappingURL=agent-executor.js.map